<template>
  <div>
      <Head title="Create a new event location" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
          <text-input v-model="form.public_name" :error="form.errors.public_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Public name')" />
          <text-input v-model="form.short_description" :error="form.errors.short_description" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Short description')" />
          <text-input v-model="form.admin_side" :error="form.errors.admin_side" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Admin side')" />
          <text-input v-model="form.public_side" :error="form.errors.public_side" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Public side')" />
          <text-input v-model="form.admin_field" :error="form.errors.admin_field" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Admin field')" />
          <text-input v-model="form.public_field" :error="form.errors.public_field" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Public field')" />
            <textarea-input name="details" v-model="form.details" :error="form.errors.public_field" class="pr-6 pb-8 w-full" :label="__('Details')"></textarea-input>
            <file-input v-model="form.image" :error="form.errors.image" class="pb-8 pr-6 w-full lg:w-1/3" type="file" accept="image/*" :label="__('Image')" />

            <div class="w-full lg:w-1/3 flex items-center justify-start">
                <img v-if="form.image" class="block mb-2 w-8 h-8 " :src="form.image" alt="" />
            </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('Event Location') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import FileInput from '@/Shared/FileInput'

export default {
  metaInfo: { title: 'Create Event Location' },
  components: {
      TextareaInput,
      FileInput,
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
      title: String
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
          public_name: null,
          short_description: null,
          image: null,
          admin_side: null,
          public_side: null,
          admin_field: null,
          public_field: null,
          details: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('event_locations.store'))
    },
  },
}
</script>
